import { SENSITIVE_WORDS } from './sensitive-words'

const patterns = SENSITIVE_WORDS.map((word) => {
  const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  return new RegExp(`\\b${escaped}\\b`, 'i')
})

export function containsSensitiveContent(text: string): boolean {
  if (!text.trim()) return false
  return patterns.some((re) => re.test(text))
}
